const get_currency_suffix = () => {
  return 'تومان';
};

export default get_currency_suffix;
